import React from "react";
import { useNavigate } from "react-router-dom";
import Portal from "../../modals/Portal";
import { useUpload } from "../../contexts/UploadContext";
import UploadWidgetHeader from "./UploadWidgetHeader";
import UploadWidgetItem from "./UploadWidgetItem";

const UploadWidget: React.FC = () => {
  const {
    uploads,
    isWidgetVisible,
    isWidgetMinimized,
    toggleWidgetMinimized,
    hideWidget,
    dismissUpload,
  } = useUpload();
  const navigate = useNavigate();

  if (!isWidgetVisible || uploads.length === 0) {
    return null;
  }

  const uploadingCount = uploads.filter(
    (u) => u.status === "uploading" || u.status === "pending",
  ).length;
  const processingCount = uploads.filter(
    (u) => u.status === "processing",
  ).length;
  const activeCount = uploadingCount + processingCount;
  const completeCount = uploads.filter((u) => u.status === "complete").length;

  return (
    <Portal>
      <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 bg-white rounded-lg shadow-xl z-50 overflow-hidden border border-gray-200">
        <UploadWidgetHeader
          activeCount={activeCount}
          uploadingCount={uploadingCount}
          processingCount={processingCount}
          completeCount={completeCount}
          totalCount={uploads.length}
          isMinimized={isWidgetMinimized}
          onToggle={toggleWidgetMinimized}
          onClose={hideWidget}
        />

        {!isWidgetMinimized && (
          <div className="max-h-64 overflow-y-auto">
            {uploads.map((upload) => (
              <UploadWidgetItem
                key={upload.id}
                upload={upload}
                onNavigate={() => {
                  if (upload.documentId) {
                    navigate(`/view/${upload.documentId}`);
                  }
                }}
                onDismiss={() => dismissUpload(upload.id)}
              />
            ))}
          </div>
        )}
      </div>
    </Portal>
  );
};

export default UploadWidget;
